
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import * as Icon from "react-bootstrap-icons";

const Navbar = () => {
  const navigate=useNavigate();
  const regName = localStorage.getItem("regName") || "User";
  const branchName = localStorage.getItem("branchName") || "";
  const branchCode = localStorage.getItem("branchcode") || "N/A";
  const user = JSON.parse(localStorage.getItem("user"));

  const handleLogout = () => {
    localStorage.clear();
    window.location.replace("/");
  };

  return (
    <nav
      className="navbar navbar-expand-lg fixed-top"
      style={{
        background: "linear-gradient(to right, #0d6efd, #0dcaf0)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
        padding: "10px 20px",
      }}
    >

      {/* Brand */}
      <NavLink
        to="/medical"
        className="navbar-brand d-flex align-items-center text-white text-decoration-none"
      >
        <div
          className="bg-white text-primary rounded-circle d-flex align-items-center justify-content-center me-2 shadow"
          style={{ width: "38px", height: "38px" }}
        >
          <Icon.HospitalFill size={20} />
        </div>

        <span className="fw-bold fs-5">
          Medical System
        </span>
      </NavLink>

      {/* Right Side */}
      <div className="ms-auto d-flex align-items-center gap-3">

        {/* User Info */}
        <div
          className="d-none d-md-flex align-items-center bg-white px-3 py-1 rounded-pill shadow-sm"
          style={{ fontSize: "14px" }}
        >
          <Icon.PersonCircle className="me-2 text-primary" />
          <span className="fw-semibold text-dark">
            {regName} <span className="text-muted">({branchCode})</span>
          </span>
        </div>

        {/* Settings */}
        {user?.userType=='S'
          ?
          <button className="btn btn-primary btn-sm fw-semibold rounded-pill shadow-sm"
          onClick={() => navigate(`userSettingsMEDICAL`)}
          >
            <Icon.GearFill className="me-1" />
          </button>
          :""
        }

        {/* Logout */}
          <button className="btn btn-danger btn-sm fw-semibold rounded-pill shadow-sm"
          onClick={() => navigate(`/`)}
          >
            <Icon.BoxArrowRight className="me-1" />
            Logout
          </button>

      </div>

    </nav>
  );
};

export default Navbar;